Trafiken.Formatter = L.Routing.Formatter.extend({
    initialize: function (options) {
        L.Routing.Formatter.prototype.initialize.call(this, options);

        this.formatDistance = function (d /* Number (meters) */) {
            var un = this.options.unitNames,
                v,
                data;

            if (this.options.units === 'imperial') {
                d = d / 1.609344;
                if (d >= 1000) {
                    data = {
                        value: this._round(d) / 1000,
                        unit: un.miles
                    };
                } else {
                    data = {
                        value: this._round(d / 1.760),
                        unit: un.yards
                    };
                }
            } else {
                v = this._round(d);
                data = {
                    value: (v >= 1000 ? v / 1000 : v).toString().replace('.', ','),
                    unit: v >= 1000 ? 'km' : 'm'
                };
            }

            return L.Util.template(this.options.distanceTemplate, data);
        };

        this.formatDuration = function (seconds) {
            seconds = typeof seconds === 'number' ? seconds : parseInt(seconds);
            const totalSeconds = Math.max(0, Math.floor(seconds));

            const SECONDS_IN_MINUTE = 60;
            const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
            const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;
            const SECONDS_IN_WEEK = 7 * SECONDS_IN_DAY;

            let remaining = totalSeconds;

            const weeks = Math.floor(remaining / SECONDS_IN_WEEK);
            remaining %= SECONDS_IN_WEEK;

            const days = Math.floor(remaining / SECONDS_IN_DAY);
            remaining %= SECONDS_IN_DAY;

            const hours = Math.floor(remaining / SECONDS_IN_HOUR);
            remaining %= SECONDS_IN_HOUR;

            const mins = Math.floor(remaining / SECONDS_IN_MINUTE);
            remaining %= SECONDS_IN_MINUTE;

            const secs = remaining;

            const parts = [];
            if (weeks > 0) parts.push(`${weeks}w`);
            if (days > 0) parts.push(`${days}d`);
            if (hours > 0) parts.push(`${hours}h`);
            if (mins > 0) parts.push(`${mins}m`);
            if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

            return parts.join(' ');
        };
    },
});